import { render, staticRenderFns } from "./WorkTabsFormDialog.vue?vue&type=template&id=f4144550"
import script from "./WorkTabsFormDialog.vue?vue&type=script&lang=js"
export * from "./WorkTabsFormDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkTabsFormDialog.vue?vue&type=style&index=0&id=f4144550&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports